import { render, staticRenderFns } from "./ed-create-text-object.vue?vue&type=template&id=31f7186e&scoped=true&"
import script from "./ed-create-text-object.ts?vue&type=script&lang=ts&"
export * from "./ed-create-text-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-create-text-object.scss?vue&type=style&index=0&id=31f7186e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f7186e",
  null
  
)

export default component.exports